module.exports = __webpack_public_path__ + "img/expandir.39409a73.svg";